__turbopack_context__.v({
  "control": "preference-controls-module__bgjXaq__control",
  "language": "preference-controls-module__bgjXaq__language",
  "select": "preference-controls-module__bgjXaq__select",
});
